import { useState } from 'react';
import { ConfirmDialog } from 'components';
import { FormattedMessage } from 'react-intl';

type DeleteProjectReportCommentDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  loading?: boolean;
};

const DeleteProjectReportCommentDialog = ({
  open,
  onClose,
  onConfirm,
  loading: externalLoading,
}: DeleteProjectReportCommentDialogProps) => {
  const [internalLoading, setInternalLoading] = useState(false);
  const loading = externalLoading ?? internalLoading;

  const handleDelete = async () => {
    try {
      setInternalLoading(true);
      await onConfirm();
    } finally {
      setInternalLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={handleDelete}
      loading={loading}
      confirmColor="error"
      title={<FormattedMessage id="projectStepManaging.deleteComment" defaultMessage="Yorum Sil" />}
      description={
        <FormattedMessage
          id="projectStepManaging.deleteCommentText"
          defaultMessage="Bu işlem onaylandıktan sonra yorum veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
    />
  );
};

export default DeleteProjectReportCommentDialog;
